const AppMarketPage = () => import(/* webpackChunkName: "AppMarketPage" */ './views/AppMarketPage.vue');

const pageProps = (route) => ({
  appCodeName: route.params.appCodeName || '',
});

const routes = [
  {
    path: '/app-market',
    name: 'appMarket',
    component: AppMarketPage,
    props: pageProps,
    meta: { i18n: 'app-market-pov', pageNameEn: 'App Market' },
  },
  {
    path: '/app-market/:appCodeName',
    name: 'appMarketAppInfo',
    component: AppMarketPage,
    props: pageProps,
    meta: { i18n: 'app-market-pov', pageNameEn: 'App Info Page' },
  },
  {
    path: '/app-market/:appCodeName/open',
    name: 'appMarketAppOpen',
    component: AppMarketPage,
    props: (route) => ({ ...pageProps(route), appOpen: true }),
    meta: { i18n: 'app-market-pov', pageNameEn: 'App Page' },
  },
];

export default routes;
